export const config = {
  appID: '14411970-78ad-47b2-a55d-af4851f9ada2',
  apiHost: 'https://api.directual.com',
};
